type EnvRecord = Record<string, string | undefined>;

const viteEnv = ((import.meta as ImportMeta & { env?: EnvRecord }).env ?? {}) as EnvRecord;
const processEnv = (typeof process !== 'undefined' ? process.env : {}) as EnvRecord;

const readEnv = (...keys: string[]) => {
  for (const key of keys) {
    const value = viteEnv[key] ?? processEnv[key];
    if (value !== undefined && value !== '') return value;
  }
  return undefined;
};

export const env = {
  apiUrl: readEnv('VITE_API_URL') || 'https://2e6esyef7v.ap-southeast-1.awsapprunner.com/api',
  posthogKey: readEnv('VITE_POSTHOG_KEY', 'VITE_POSTHOG_TOKEN'),
  posthogHost: readEnv('VITE_POSTHOG_HOST') || 'https://us.i.posthog.com',
  perfRender: readEnv('VITE_PERF_RENDER') === '1',
  disableErrorReporting: readEnv('VITE_DISABLE_ERROR_REPORTING') === '1',
  commitHash: readEnv('VITE_COMMIT_SHA'),
  buildTime: readEnv('VITE_COMMIT_TIMESTAMP')
};
